import { Link, useNavigate } from 'react-router-dom';
import { Minus, Plus, Trash2, ArrowRight } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { gbp, setPageMeta } from '../lib/shop';
import { useEffect } from 'react';

export default function CartPage() {
  const { items, setQty, remove, subtotal } = useCart();
  const navigate = useNavigate();
  useEffect(() => { setPageMeta('Basket'); }, []);

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10" data-testid="basket-page">
      <p className="font-mono2 text-[11px] uppercase tracking-[0.25em] text-[#8A8F95]">Your selection</p>
      <h1 className="font-display font-black uppercase text-4xl sm:text-5xl tracking-tight mt-2 mb-8">Basket</h1>

      {items.length === 0 ? (
        <div className="border hairline bg-white p-10 text-center" data-testid="basket-empty">
          <p className="font-display font-bold uppercase text-2xl">Your basket is empty</p>
          <Link to="/products" className="inline-block mt-6 bg-[#0B0F12] text-white px-6 py-3 font-mono2 text-xs uppercase tracking-widest hover:bg-[#E54D2E] transition-colors">Browse catalogue</Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-8">
          <div className="space-y-4">
            {items.map((it) => (
              <div key={it.key} data-testid={`basket-item-${it.key}`} className="flex gap-4 border hairline bg-white p-4">
                <img src={it.image} alt="" className="w-20 h-20 object-cover bg-[#F4F4F0]" />
                <div className="flex-1 min-w-0">
                  <p className="font-display font-bold uppercase tracking-wide leading-tight">{it.name}</p>
                  <p className="font-mono2 text-[10px] uppercase tracking-wider text-[#8A8F95] mt-0.5">{it.strength} · {it.format}</p>
                  <div className="flex items-center gap-3 mt-3">
                    <div className="flex items-center border hairline">
                      <button data-testid={`basket-minus-${it.key}`} onClick={() => setQty(it.key, it.quantity - 1)} className="p-1.5"><Minus className="w-3.5 h-3.5" /></button>
                      <span className="px-2 font-mono2 text-sm">{it.quantity}</span>
                      <button data-testid={`basket-plus-${it.key}`} onClick={() => setQty(it.key, it.quantity + 1)} className="p-1.5"><Plus className="w-3.5 h-3.5" /></button>
                    </div>
                    <button data-testid={`basket-remove-${it.key}`} onClick={() => remove(it.key)} className="p-1.5 text-[#8A8F95] hover:text-[#E54D2E]"><Trash2 className="w-4 h-4" /></button>
                  </div>
                </div>
                <div className="text-right">
                  <p className="font-mono2 text-sm font-semibold">{gbp(it.price * it.quantity)}</p>
                  <p className="font-mono2 text-[10px] text-[#8A8F95]">{gbp(it.price)} each</p>
                </div>
              </div>
            ))}
          </div>
          <div className="border hairline bg-white p-6 h-fit">
            <p className="font-display font-bold uppercase text-xl mb-4">Summary</p>
            <div className="flex justify-between font-mono2 text-sm py-2 border-b hairline">
              <span className="uppercase tracking-wider text-[#575B60]">Subtotal</span>
              <span data-testid="basket-subtotal" className="font-semibold">{gbp(subtotal)}</span>
            </div>
            <p className="text-[11px] text-[#8A8F95] my-3">Shipping, discount codes and the final total are calculated at checkout.</p>
            <button data-testid="basket-checkout-button" onClick={() => navigate('/checkout')}
              className="w-full bg-[#0B0F12] text-white py-3.5 font-mono2 text-xs uppercase tracking-[0.2em] hover:bg-[#E54D2E] transition-colors flex items-center justify-center gap-2">
              Checkout <ArrowRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
